import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import ReactTable, { ReactTableDefaults } from 'react-table';

import {
  Loading,
  ExamTemplateInTableMenu,
  TempStatistics,
  ReactTableFilterDatePicker,
  ReactTableSearch,
  ReactTablePagination,
  ReactTableHeaderText,
  ExamTemplateInTableCheck
} from 'components';

import { Icon, Label, Popup, Image } from 'semantic-ui-react';
import { Checkbox } from 'material-ui';

import * as commonVar from 'libs/commonVar';

import moment from 'moment';
import 'moment/locale/ko';
import 'moment/locale/ja';

import classNames from 'classnames/bind';
import styles from './ExamTemplateList.css';
const cx = classNames.bind(styles);

moment.locale(localStorage.getItem('language'));
class ExamTemplateList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      allChecked: false
    };
  }

  // 전체 선택 체크박스 제어
  setAllCheck = value => {
    this.setState({
      allChecked: value
    });
  };

  render() {
    const { formatMessage } = this.props.intl;
    const { data, fromNowView, isAuth, attachData, templatePhishing, attachIndexList, ...rest } = this.props;
    // 검색 (상단)
    const { searchObj } = this.props;
    // 필터
    const {
      handleChangeDateFilter,
      isServiceTemplateFilter,
      examTypeTemplateFilter,
      downloadTypeTemplateFilter,
      receiveTemplateFilter,
      cancleCheck,
      filterClose,
      executeFilter,
      onFilterCancel
    } = this.props;

    // 현재 페이지 이동 (하단)
    const { handlePagination } = this.props;

    const { setAllCheck } = this;
    const { allChecked } = this.state;

    const columns = [
      // 체크박스
      {
        Header: <ExamTemplateInTableCheck examData={data} setAllCheck={setAllCheck} allChecked={allChecked} />,
        resizable: false,
        sortable: false,
        width: 70,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ original }) => {
          return <ExamTemplateInTableCheck examData={data} templateInfo={{ ...original }} allChecked={allChecked} />;
        }
      },
      {
        Header: <ReactTableHeaderText title={<Icon name="setting" />} />,
        resizable: false,
        sortable: false,
        width: 114,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ original }) => {
          return <ExamTemplateInTableMenu isAuth={isAuth} templateInfo={{ ...original }} />;
        }
      },
      {
        Header: <ReactTableHeaderText title={'No'} />,
        accessor: 'serviceTemplateNo',
        sortable: true,
        resizable: true,
        width: 72,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center number-text'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value) {
            printValue = value;
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            {
              key: '1',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_2', defaultMessage: '기 본' })),
              value: 1
            },
            {
              key: '0',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_3', defaultMessage: '사용자' })),
              value: 0
            }
          ];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamTemplateList_1', defaultMessage: '구분' }))}
            // filter={
            //   <ReactTableFilterDropdown
            //     listItem={listItem}
            //     filter={searchObj.filterData}
            //     searchObj={searchObj}
            //     // handleChangeFilter={handleChangeFilter}
            //     column={rest.column.id}
            //   />
            // }
            />
          );
        },
        accessor: 'serviceTemplateNo',
        id: 'templatePick',
        sortable: true,
        resizable: true,
        width: 83,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center', 'template-class-label'),
        Cell: ({ value }) => {
          let printValue = (
            <Label basic size="small" className={cx('template-type-label color-temp-system')}>
              {defineMessages(formatMessage({ id: 'ExamTemplateList_2', defaultMessage: '기 본' }))}
            </Label>
          );
          if (value) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-temp-user')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_3', defaultMessage: '사용자' }))}
              </Label>
            );
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            {
              key: '1',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_32', defaultMessage: '경고 안내' })),
              value: 1
            },
            {
              key: '2',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_14', defaultMessage: '모의 악성파일' })),
              value: 2
            },
            {
              key: '3',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_15', defaultMessage: '실태 조사' })),
              value: 3
            },
            {
              key: '4',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_16', defaultMessage: '피싱 유도' })),
              value: 4
            }
          ];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamTemplateList_13', defaultMessage: '훈련 유형' }))}
            // filter={
            //   <ReactTableFilterDropdown
            //     listItem={listItem}
            //     filter={searchObj.filterData}
            //     // handleChangeFilter={handleChangeFilter}
            //     column={rest.column.id}
            //   />
            // }
            />
          );
        },
        accessor: 'examType',
        id: 'examType',
        sortable: true,
        resizable: true,
        width: 131,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: props => {
          let printValue = '-';
          if (props.value === 1 && props.original.attachExamType === 1) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-temp-warning')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_32', defaultMessage: '경고 안내' }))}
              </Label>
            );
          } else if (props.value === 1 && props.original.attachExamType === 2) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-temp-file')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_14', defaultMessage: '모의 악성파일' }))}
              </Label>
            );
          } else if (props.value === 1 && props.original.attachExamType === 3) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-temp-research')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_15', defaultMessage: '실태 조사' }))}
              </Label>
            );
          } else if (props.value === 4) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-temp-phishing')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_16', defaultMessage: '피싱 유도' }))}
              </Label>
            );
          } else if (props.value === 5) {
            printValue = (
              <Label basic size="small" className={cx('template-type-label color-temp-phishing-direct')}>
                {defineMessages(formatMessage({ id: 'ExamTemplateList_36', defaultMessage: '피싱 안내' }))}
              </Label>
            );
          } else {
            // 나머지
          }
          return printValue;
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={
              <Popup
                trigger={
                  <a
                    href={'/attachRestrict_' + localStorage.getItem('language') + '.html'}
                    target="restrict"
                    className={cx('attach-list-restrict')}
                    onClick={e => e.stopPropagation()}>
                    {defineMessages(formatMessage({ id: 'ExamTemplateList_33', defaultMessage: '첨부파일 정보' }))}
                    <Icon name="info circle" className={cx('ml-5')} />
                  </a>
                }>
                {defineMessages(
                  formatMessage({ id: 'ExamAttachList_19', defaultMessage: "부가기능, 제약사항 설명 페이지 'Click!'" })
                )}
              </Popup>
            }
          />
        ),
        accessor: 'attachSubject',
        sortable: false,
        width: 150,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: props => {
          const attachListInFo = props.original.attachInfoNo;
          const examType = props.original.examType;
          let printValue = null;
          if (attachListInFo && attachData.size > 0 && attachIndexList.size > 0) {
            const aData = attachData.get(String(attachIndexList.get(String(attachListInFo))));

            if (aData) {
              const attachFunctionKey = Object.keys(JSON.parse(aData.get('attachFunction')));
              const attachFunction =
                attachFunctionKey.length > 0
                  ? attachFunctionKey.map((keys, i) => {
                    return (
                      <Label key={i} basic size="small" className={cx('template-type-label color-bg-attachFunction')}>
                        {keys}
                      </Label>
                    );
                  })
                  : '-';

              const attachRestrictKey = Object.keys(JSON.parse(aData.get('attachRestrict')));
              const attachRestrict =
                attachRestrictKey.length > 0
                  ? attachRestrictKey.map((keys, i) => {
                    return (
                      <Label key={i} basic size="small" className={cx('template-type-label color-bg-attachRestrict')}>
                        {keys}
                      </Label>
                    );
                  })
                  : '-';
              printValue = (
                <Popup
                  className={cx('temp-attachCellPopup')}
                  trigger={<div>{aData.get('attachSubject')}</div>}
                  position="right center">
                  <div>
                    <div className={cx('temp-attachCellPopup-each')}>
                      <span className={cx('temp-attachCellPopup-title')}>No</span>
                      <span className={cx('temp-attachCellPopup-content')}>{aData.get('attachInfoNo')}</span>
                    </div>
                    <div className={cx('temp-attachCellPopup-each')}>
                      <span className={cx('temp-attachCellPopup-title')}>
                        {defineMessages(formatMessage({ id: 'ExamAttachAdd_18', defaultMessage: '구분' }))}
                      </span>
                      <span className={cx('temp-attachCellPopup-content')}>
                        {aData.get('attachCategory') === 1 && (
                          <Label basic size="small" className={cx('template-type-label color-attach-exe')}>
                            {defineMessages(formatMessage({ id: 'ExamAttachList_15', defaultMessage: '실행파일' }))}
                          </Label>
                        )}
                        {aData.get('attachCategory') === 2 && (
                          <Label basic size="small" className={cx('template-type-label color-attach-lnk')}>
                            {defineMessages(formatMessage({ id: 'ExamAttachList_16', defaultMessage: '바로가기' }))}
                          </Label>
                        )}
                        {aData.get('attachCategory') === 3 && (
                          <Label basic size="small" className={cx('template-type-label color-attach-doc')}>
                            {defineMessages(formatMessage({ id: 'ExamAttachList_17', defaultMessage: '문서파일' }))}
                          </Label>
                        )}
                        {aData.get('attachCategory') === 4 && (
                          <Label basic size="small" className={cx('template-type-label color-attach-html')}>
                            {defineMessages(formatMessage({ id: 'ExamAttachList_18', defaultMessage: '웹문서' }))}
                          </Label>
                        )}
                      </span>
                    </div>
                    <div className={cx('temp-attachCellPopup-each')}>
                      <span className={cx('temp-attachCellPopup-title')}>
                        {defineMessages(formatMessage({ id: 'ExamTemplateList_13', defaultMessage: '훈련 유형' }))}
                      </span>
                      <span className={cx('temp-attachCellPopup-content')}>
                        {aData.get('attachExamType') === 1 && (
                          <Label basic size="small" className={cx('template-type-label color-temp-warning')}>
                            {defineMessages(formatMessage({ id: 'ExamTemplateList_32', defaultMessage: '경고 안내' }))}
                          </Label>
                        )}
                        {aData.get('attachExamType') === 2 && (
                          <Label basic size="small" className={cx('template-type-label color-temp-file')}>
                            {defineMessages(
                              formatMessage({ id: 'ExamTemplateList_14', defaultMessage: '모의 악성파일' })
                            )}
                          </Label>
                        )}
                        {aData.get('attachExamType') === 3 && (
                          <Label basic size="small" className={cx('template-type-label color-temp-research')}>
                            {defineMessages(formatMessage({ id: 'ExamTemplateList_15', defaultMessage: '실태 조사' }))}
                          </Label>
                        )}
                      </span>
                    </div>
                    <div className={cx('temp-attachCellPopup-each')}>
                      <span className={cx('temp-attachCellPopup-title')}>
                        {defineMessages(formatMessage({ id: 'ExamAttachList_3', defaultMessage: '아이콘' }))}
                      </span>
                      <span className={cx('temp-attachCellPopup-content')}>
                        <Image
                          className={cx('attach-fileIcon')}
                          src={'/fdata/attachFile/' + aData.get('attachInfoNo') + '/' + aData.get('fileIcon')}
                        />
                      </span>
                    </div>
                    <div className={cx('temp-attachCellPopup-each')}>
                      <span className={cx('temp-attachCellPopup-title')}>
                        {defineMessages(formatMessage({ id: 'ExamAttachList_4', defaultMessage: '확장자' }))}
                      </span>
                      <span className={cx('temp-attachCellPopup-content')}>{aData.get('fileExt')}</span>
                    </div>
                    <div className={cx('temp-attachCellPopup-each')}>
                      <span className={cx('temp-attachCellPopup-title')}>
                        {defineMessages(formatMessage({ id: 'ExamAttachAdd_19', defaultMessage: '부가 기능' }))}
                      </span>
                      <span className={cx('temp-attachCellPopup-content')}>{attachFunction}</span>
                    </div>
                    <div className={cx('temp-attachCellPopup-each')}>
                      <span className={cx('temp-attachCellPopup-title')}>
                        {defineMessages(formatMessage({ id: 'ExamAttachAdd_20', defaultMessage: '제약 사항' }))}
                      </span>
                      <span className={cx('temp-attachCellPopup-content')}>{attachRestrict}</span>
                    </div>
                  </div>
                </Popup>
              );
            }
          }
          return (examType === 1 && !!attachListInFo) ? printValue : '-';
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'MyPageMenu_7', defaultMessage: '피싱 페이지' }))}
          />
        ),
        accessor: 'phishingName',
        sortable: true,
        minWidth: 261,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: props => {
          const phishingNo = props.original.phishingNo;
          const examType = props.original.examType;
          let phishingArray = [];
          let phishingInfo = {};
          phishingArray = templatePhishing.toJS();
          if (phishingNo && phishingArray.length > 0) {
            phishingArray.map((item, index) => {    
              if (examType === 4 && item.phishingNo === phishingNo) {
                phishingInfo = item;
              }
            });
          }
          
          return examType === 4 ? phishingInfo.phishingName : '-';
            // if (aData) {
            //   const attachFunctionKey = Object.keys(JSON.parse(aData.get('attachFunction')));
            //   const attachFunction =
            //     attachFunctionKey.length > 0
            //       ? attachFunctionKey.map((keys, i) => {
            //         return (
            //           <Label key={i} basic size="small" className={cx('template-type-label color-bg-attachFunction')}>
            //             {keys}
            //           </Label>
            //         );
            //       })
            //       : '-';

            //   const attachRestrictKey = Object.keys(JSON.parse(aData.get('attachRestrict')));
            //   const attachRestrict =
            //     attachRestrictKey.length > 0
            //     }
            //   }
                        
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamTemplateList_5', defaultMessage: '템플릿명' }))}
          />
        ),
        accessor: 'templateName',
        sortable: true,
        minWidth: 261,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamTemplateEdit_14', defaultMessage: '메일 제목' }))}
          />
        ),
        accessor: 'subject',
        sortable: true,
        minWidth: 261,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamTemplateList_30', defaultMessage: '훈련 결과' }))}
          />
        ),
        accessor: 'statistics',
        resizable: true,
        sortable: true,
        width: 140,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          if (value) {
            if (value === 'serviceTemplate') {
              return '-';
            } else {
              return <TempStatistics data={value} />;
            }
          } else {
            return formatMessage({ id: 'StartExamWizardContent_99', defaultMessage: '훈련 결과 없음' });
          }
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamTemplateList_6', defaultMessage: '발송자명' }))}
          />
        ),
        accessor: 'senderName',
        sortable: true,
        minWidth: 106,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamTemplateList_7', defaultMessage: '발송자 이메일' }))}
          />
        ),
        accessor: 'senderEmail',
        sortable: true,
        minWidth: 199,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td')
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            {
              key: '1',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_29', defaultMessage: '첨부 파일' })),
              value: 1
            },
            {
              key: '2',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_28', defaultMessage: '링크 첨부' })),
              value: 2
            }
          ];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamTemplateList_27', defaultMessage: '다운로드 유형' }))}
            // filter={
            //   <ReactTableFilterDropdown
            //     listItem={listItem}
            //     filter={searchObj.filterData}
            //     // handleChangeFilter={handleChangeFilter}
            //     column={rest.column.id}
            //   />
            // }
            />
          );
        },
        accessor: 'linkAttach',
        id: 'linkAttach',
        sortable: true,
        resizable: false,
        width: 145,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 1) {
            printValue = defineMessages(formatMessage({ id: 'ExamTemplateList_29', defaultMessage: '첨부 파일' }));
          } else if (value === 2) {
            printValue = defineMessages(formatMessage({ id: 'ExamTemplateList_28', defaultMessage: '링크 첨부' }));
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            {
              key: '1',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_9', defaultMessage: '원본' })),
              value: 1
            },
            {
              key: '2',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_10', defaultMessage: '압축' })),
              value: 2
            },
            {
              key: '3',
              text: defineMessages(formatMessage({ id: 'ExamTemplateList_11', defaultMessage: '비번압축' })),
              value: 3
            }
          ];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamTemplateList_8', defaultMessage: '첨부 유형' }))}
            />
          );
        },
        accessor: 'attachType',
        id: 'attachType',
        sortable: true,
        resizable: false,
        width: 143,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 1) {
            printValue = defineMessages(formatMessage({ id: 'ExamTemplateList_9', defaultMessage: '원본' }));
          } else if (value === 2) {
            printValue = defineMessages(formatMessage({ id: 'ExamTemplateList_10', defaultMessage: '압축' }));
          } else if (value === 3) {
            printValue = defineMessages(formatMessage({ id: 'ExamTemplateList_11', defaultMessage: '비번압축' }));
          } else {
            // 나머지
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [{ key: '1', text: 'O', value: '1' }, { key: '0', text: '-', value: '0' }];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamTemplateList_12', defaultMessage: '수신 성공' }))}
            // filter={
            //   <ReactTableFilterDropdown
            //     listItem={listItem}
            //     filter={searchObj.filterData}
            //     // handleChangeFilter={handleChangeFilter}
            //     column={rest.column.id}
            //   />
            // }
            />
          );
        },
        accessor: 'templateReceive',
        id: 'templateReceive',
        sortable: true,
        resizable: false,
        width: 110,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 1) {
            printValue = 'O';
          }
          return printValue;
        }
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamTemplateList_17', defaultMessage: '등록일시' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={data => {
                    handleChangeDateFilter('RegEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'regEpoch',
        minWidth: 177,
        resizable: false,
        sortable: true,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return (
            <div>
              <span className={cx('log-reg-date-normal')}>{moment.unix(value).format(dateFormat + ' HH:mm:ss')}</span>
              <span className={cx('log-reg-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          );
        }
      }
    ];

    if (isAuth === 2) {
      columns.splice(1, 0, {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamTemplateList_19', defaultMessage: '템플릿No' }))}
          />
        ),
        accessor: 'templateNo',
        id: 'examTemplateNo',
        resizable: true,
        sortable: true,
        width: 100,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center number-text')
      });

      columns.splice(
        13,
        0,
        {
          Header: (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamTemplateList_20', defaultMessage: '공개' }))}
            />
          ),
          accessor: 'templatePublic',
          id: 'templatePublic',
          sortable: true,
          resizable: false,
          width: 83,
          headerClassName: cx('react-table-th', 'overflow-visible'),
          className: cx('react-table-td', 'text-align-center'),
          Cell: ({ value }) => {
            let printValue = '-';
            if (value === 1) {
              printValue = 'O';
            }
            return printValue;
          }
        },
        {
          Header: (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamTemplateList_18', defaultMessage: '서비스No' }))}
            />
          ),
          accessor: 'serviceNo',
          resizable: false,
          sortable: true,
          width: 110,
          headerClassName: cx('react-table-th'),
          className: cx('react-table-td', 'text-align-center number-text'),
          Cell: ({ value }) => {
            let printValue = '-';
            if (value) {
              printValue = value;
            }
            return printValue;
          }
        },
        {
          Header: (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'AdminUserList_8', defaultMessage: '서비스명' }))}
            />
          ),
          accessor: 'serviceName',
          sortable: true,
          minWidth: 143,
          headerClassName: cx('react-table-th'),
          className: cx('react-table-td sub-text')
        }
      );
    }

    const { TbodyComponent: tbadyWrapper } = ReactTableDefaults;

    return (
      <div className={cx('react-table-area', fromNowView ? 'from-now-view' : '')}>
        <ReactTableSearch
          searchObj={searchObj}
          listData={data}
          //필터 영역
          filters={{
            isServiceTemplateFilter: isServiceTemplateFilter,
            examTypeTemplateFilter: examTypeTemplateFilter,
            downloadTypeTemplateFilter: downloadTypeTemplateFilter,
            receiveTemplateFilter: receiveTemplateFilter
          }}
          cancleCheck={cancleCheck}
          filterClose={filterClose}
          executeFilter={executeFilter}
          onFilterCancel={onFilterCancel}
        />
        <div className={cx('react-table')}>
          <ReactTable
            columns={columns}
            data={data}
            sortable={false}
            filterable={false}
            showPagination={false}
            showPageSizeOptions={false}
            defaultSorted={[
              {
                id: 'serviceTemplateNo',
                desc: true
              }
            ]}
            loadingText={defineMessages(
              formatMessage({ id: 'ExamTemplateList_23', defaultMessage: '데이터 로딩중...' })
            )}
            LoadingComponent={({ ...rest }) => <Loading active={rest.loading} content={rest.loadingText} />}
            FilterComponent={({ ...rest }) => <div />}
            TbodyComponent={({ ...rest }) => (
              <div style={{ ...rest.style }} className={cx('react-table-tbody-wrapper')}>
                <tbadyWrapper {...rest} className={cx('rt-tbody', rest.className ? rest.className : '', data.length < 2 ? 'single' : '')} />
              </div>
            )}
            NoDataComponent={({ ...rest }) => (
              <div className={cx('noData-area')}>
                <Image src="/img/table/nodata_icon.png" />
                {defineMessages(formatMessage({ id: 'ExamTemplateList_24', defaultMessage: '데이터가 없습니다.' }))}
              </div>
            )}
            getTheadThProps={(state, rowInfo, column) => {
              const filter = [];
              if (column) {
                // 필터 처리
                if (typeof searchObj.filterData[column.id] !== 'undefined') {
                  filter.push('isFiltered');
                }
                // 정렬 제공 안하는 header
                if (!column.sortable) {
                  filter.push('no-sort');
                }

                return filter.length > 0
                  ? {
                    className: filter.join(' ')
                  }
                  : {};
              }
            }}
            getTrProps={(state, rowInfo, column) => {
              if (rowInfo && rowInfo.original && rowInfo.original.templatePublic === 0) {
                return {
                  style: {
                    fontStyle: 'italic',
                    color: '#aaaaaa'
                  }
                };
              } else {
                return {};
              }
            }}
            minRows={data ? (data.length !== 0 && data.length < 2 ? 2 : data.length) : searchObj.defaultPageSize}
            {...rest}
          />
        </div>
        <ReactTablePagination
          currentPage={rest.page}
          totalPages={rest.pages ? rest.pages : 0}
          handlePagination={handlePagination}
        />
      </div>
    );
  }
}

export default injectIntl(ExamTemplateList);



// WEBPACK FOOTER //
// ./src/script/components/examTemplate/ExamTemplateList.js